import * as React from 'react';
import Wrapper from './Wrapper';

const Export = Wrapper(props => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.00005 8.00267H16.5M16.5 8.00267L14 10.5027M16.5 8.00267L14 5.50267M11.5 11V14C11.5238 14.5268 11.1174 14.9737 10.5907 15H2.40871C1.8823 14.9734 1.47627 14.5265 1.50005 14V2C1.4759 1.47332 1.88213 1.02625 2.40871 1H10.5907C11.1174 1.02625 11.5238 1.47321 11.5 2V5"
      stroke="#3E719B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export default Export;
